import React from 'react';
import { Outlet } from 'react-router-dom';
import ExamplesNavbar from "./Navbars/ExamplesNavbar";
import DemoFooter from "./Footers/DemoFooter";

function Layout() {
    return (
        <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
            <ExamplesNavbar />
            <div style={{ flex: 1 }}>
                <Outlet />
            </div>
            <DemoFooter />
        </div>
    );
}

export default Layout;
